import { CheckableFieldComponent } from "./chunk-6B4YYPG7.js";
import { Toggle_default } from "./chunk-GQONRKLW.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/ToggleField/ToggleField.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
import { Switch } from "@headlessui/react";
var ToggleField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      description,
      badge,
      secondaryAction,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "description", "badge", "secondaryAction", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */React.createElement(Switch.Group, {
    as: CheckableFieldComponent,
    id,
    name,
    label,
    description,
    badge,
    secondaryAction,
    variant: "secondary",
    validation,
    validationMessage,
    className: clsx("pd-toggle-field", className)
  }, /* @__PURE__ */React.createElement(Toggle_default, __spreadValues({
    ref,
    screenReaderLabel: label,
    className: "pd-checkable-field__input pd-toggle-field__input"
  }, rest)), /* @__PURE__ */React.createElement(Switch.Label, {
    className: "pd-checkable-field__wrap pd-toggle-field__wrap"
  }, /* @__PURE__ */React.createElement(CheckableFieldComponent.Label, {
    className: "pd-toggle-field__label"
  }), /* @__PURE__ */React.createElement(Switch.Description, {
    as: CheckableFieldComponent.Description,
    className: "pd-toggle-field__description"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.SecondaryAction, {
    className: "pd-toggle-field__secondary-action",
    onClick: e => e.stopPropagation()
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Badge, {
    className: "pd-toggle-field__badge"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Validation, {
    className: "pd-toggle-field__validation"
  })));
});
var ToggleField_default = ToggleField;
export { ToggleField_default };